import graphql__49b55f3967431283b2688f6b1801b515 from "./__generated__/useBulkTravelServiceInformationV1Query.graphql";
import { useMemo } from "react";
import { generateUseGraphqlQuery } from "@trainline-shareable/graphql";
const graphqlQuery = (graphql__49b55f3967431283b2688f6b1801b515.hash && graphql__49b55f3967431283b2688f6b1801b515.hash !== "49b55f3967431283b2688f6b1801b515" && console.error("The definition of 'useBulkTravelServiceInformationV1Query' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), graphql__49b55f3967431283b2688f6b1801b515);
const TransportModesForTransitLegs = ["train", "bus", "ferry", "coach"];
const mapJourneyToTsiPayloads = (journeyPlan) => journeyPlan.legs.map(({ transportModeName, id, timetableId, destination, origin, carrierUrn, localDepartAt }) => {
  const shouldAttemptTSICall = transportModeName && TransportModesForTransitLegs.includes(transportModeName);
  if (shouldAttemptTSICall && (timetableId || id) && (destination == null ? void 0 : destination.code) && (origin == null ? void 0 : origin.code) && carrierUrn) {
    return {
      carrierUrn,
      timetableId: timetableId || id,
      legDepartureTime: localDepartAt,
      legDestination: destination.code,
      legOrigin: origin.code
    };
  }
  return void 0;
}).filter((item) => !!item);
const { useGraphqlQuery } = generateUseGraphqlQuery("@trainline-shareable/journey-live-tracker", "1.2.1");
const TEN_SEC_IN_MS = 10 * 1e3;
const TWENTY_SEC_IN_MS = 20 * 1e3;
const REFETCH_INTERVAL = TWENTY_SEC_IN_MS;
const STALE_TIME = TEN_SEC_IN_MS;
const useBulkTravelServicePayload = (journeyPlan, disableFetch = false) => {
  const variables = useMemo(() => {
    const tsiPayloads = mapJourneyToTsiPayloads(journeyPlan);
    return { requestBody: { tsiPayloads } };
  }, [journeyPlan]);
  return useGraphqlQuery(graphqlQuery, variables, {
    refetchOnWindowFocus: "always",
    refetchOnReconnect: true,
    refetchOnMount: true,
    refetchInterval: REFETCH_INTERVAL,
    staleTime: STALE_TIME,
    useErrorBoundary: false,
    enabled: !disableFetch
  });
};
const testFuncs = { mapJourneyToTsiPayloads };
var useBulkTravelServiceInformation_default = useBulkTravelServicePayload;
export {
  REFETCH_INTERVAL,
  useBulkTravelServiceInformation_default as default,
  testFuncs
};
